import type { ComponentProps } from "react";

import { cn } from "@/utils/cn";

export type BadgeTone = "blue" | "green" | "red" | "yellow" | "teal" | "cyan" | "indigo" | "violet" | "orange" | "gray";

const TONE_CLASS: Record<BadgeTone, string> = {
  blue: "bg-badge-blue",
  green: "bg-badge-green",
  red: "bg-badge-red",
  yellow: "bg-badge-yellow",
  teal: "bg-badge-teal",
  cyan: "bg-badge-cyan",
  indigo: "bg-badge-indigo",
  violet: "bg-badge-violet",
  orange: "bg-badge-orange",
  gray: "bg-badge-gray",
};

interface IconBadgeProps extends ComponentProps<"div"> {
  tone?: BadgeTone;
  color?: string;
}

export default function IconBadge({ tone, color, className, style, ...props }: IconBadgeProps) {
  return (
    <div
      className={cn(
        "flex aspect-square h-7 items-center justify-center rounded-lg text-white inset-shadow-inner-glow-lg",
        tone && TONE_CLASS[tone],
        className,
      )}
      style={color ? { backgroundColor: color, ...style } : style}
      {...props}
    />
  );
}
